import { Properties } from 'csstype';
import { grid } from 'styled-system';
import { CoreUiStyleType } from './types';

export interface GridStyleProps {
  gridColumn?: CoreUiStyleType<Properties['gridColumn']>;
  gridRow?: CoreUiStyleType<Properties['gridRow']>;
  gridAutoFlow?: CoreUiStyleType<Properties['gridAutoFlow']>;
  gridAutoColumns?: CoreUiStyleType<Properties['gridAutoColumns']>;
  gridAutoRows?: CoreUiStyleType<Properties['gridAutoRows']>;
  gridTemplateColumns?: CoreUiStyleType<Properties['gridTemplateColumns']>;
  gridTemplateRows?: CoreUiStyleType<Properties['gridTemplateRows']>;
  gridTemplateAreas?: CoreUiStyleType<Properties['gridTemplateAreas']>;
  gridArea?: CoreUiStyleType<Properties['gridArea']>;
  justifySelf?: CoreUiStyleType<Properties['justifySelf']>;
}

export const gridStylePropNames: (keyof GridStyleProps)[] = [
  'gridColumn',
  'gridRow',
  'gridAutoFlow',
  'gridAutoColumns',
  'gridAutoRows',
  'gridTemplateColumns',
  'gridTemplateRows',
  'gridTemplateAreas',
  'gridArea',
  'justifySelf',
];

export { grid };
